// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sponsors: UserTick,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const orders: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="Order Management" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [

    {
      id: 'orders',
      title: <FormattedMessage id="orders" />,
      type: 'collapse',
      icon: icons.orders,
      children: [
        {
          id: 'orders-list',
          title: <FormattedMessage id="orders-list" />,
          type: 'item',
          url: '/apps/orders/orders-list',
          breadcrumbs: false
        },

      ]
    },
    {
      id: 'return',
      title: <FormattedMessage id="Order Return" />,
      type: 'collapse',
      icon: icons.return,
      children: [
        {
          id: 'return-list',
          title: <FormattedMessage id="Return list" />,
          type: 'item',
          url: '/apps/return/return-list',
          breadcrumbs: false
        },

      ]
    },
  ]
};

export default orders;
